const numberKeyPrefix = "_"; // if number key is used in state object, it will be prefixed with this value.

export function getKey(value) {
    if (typeof value === "number") {
        return numberKeyPrefix + value.toString();
    }
    if (!value) {
        return "undefined";
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    if (value.toString().trim() === "") {
        return "empty";
    }
    if (typeof value === "number") {
        console.warn("Using Number key in a state object is not verified", value);
        return numberKeyPrefix + value.toString();
    }
    return value.toString();
}

